var isNull = function isNull(val) {
  return val === null;
};

export default isNull;